var $66bb08566471494b$exports = {};
$66bb08566471494b$exports = {
    "info": `Informations`,
    "negative": `Erreur`,
    "notice": `Avertissement`,
    "positive": `Succ\xe8s`
};


export {$66bb08566471494b$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
